import { useMutation } from "@tanstack/react-query";
import { validateCart } from "../services/CartItemsService";
import { message } from "antd";


export const useValidateCart = (onSuccess, onError) => {
  return useMutation({
    mutationFn: validateCart,
    onSuccess: (data) => {
      if (data.isValid) {
        message.success("Cart validated successfully ✅");
        if (onSuccess) onSuccess(data);
      } else {
        message.warning("Some items are out of stock ❗");
        if (onError) onError(data);
      }
    },
    onError: (error) => {
      message.error(error.response?.data || "Cart validation failed ❌");
      if (onError) onError(error);
    },
  });
};